export const debug = token => {
    return window.location.search.toLowerCase().indexOf("debug=" + token) >= 0;
};